import React from 'react';
import axios from 'axios';
import { CompanyContext } from '../CompanyContext';

const useFetch = () => {
    const { setError } = React.useContext(CompanyContext);

    const [data, setData] = React.useState({});
    const [opts, setOpts] = React.useState({});
    const [isLoading, setIsLoading] = React.useState(false);
    const [promise, setPromise] = React.useState({});

    const doFetch = (opts) => {
        setOpts(opts);

        return new Promise((resolve, reject) => {
            setPromise({ resolve, reject });
        });
    }

    React.useEffect(() => {
        const fetchData = async (resolve, reject) => {
            setError(null);
            setIsLoading(true);

            try {
                const result = await axios(opts);
                resolve(result);
                setData(result.data);
            } catch (error) {
                const status = error.response?.status;

                if (!error.response) {
                    setError({
                        Message: 'This site is currently experiencing technical difficulty',
                        Dismissable: true,
                        Code: '0x03'
                    });
                } else if (status >= 500) {
                    setError({
                        Message: 'This site is currently experiencing technical difficulty',
                        Dismissable: true,
                        Code: '0x02'
                    });
                }

                reject(error);
            } finally {
                setPromise({});
                setIsLoading(false);
            }
        };

        if (promise.resolve && promise.reject) {
            fetchData(promise.resolve, promise.reject);
        }
    }, [promise]);

    return { data, isLoading, doFetch };
}

export { useFetch };
